import classNames from 'classnames';
import { uniqueId } from 'lodash';

import { RendererProps } from 'plugins/types';
import { DATASOURCE, findSchema } from 'schemas';
import IcomoonIcon from 'components/common/Icon/IcomoonIcon';
import DataSourceIcon from 'components/common/Icon/DataSourceIcon';

import { TooltipPlacement, TruncateWithTooltip } from '../components';

import './DataSourceFieldRenderer.scss';
import './GenericFieldRenderer.scss';

export enum DataSourceFieldRendererSize {
  MEDIUM = 16,
  LARGE = 24,
}

type DataSourceFieldRendererProps = RendererProps & {
  size?: DataSourceFieldRendererSize;
};

export const DataSourceFieldRenderer = ({ fieldId, value, size }: DataSourceFieldRendererProps): JSX.Element => {
  const schema = findSchema(String(value));
  const isGenericDataSource = schema?.dataSource === DATASOURCE.GENERIC_XDR;
  const label = isGenericDataSource ? String(value) ?? 'Generic' : String(schema?.dataSourceLabel ?? '');
  const valueClassnames = classNames('GenericFieldRenderer__Value', {
    'GenericFieldRenderer__Value--Large': size === DataSourceFieldRendererSize.LARGE,
  });
  const iconClassnames = classNames('GenericFieldRenderer__Icon', {
    'GenericFieldRenderer__Icon--Large': size === DataSourceFieldRendererSize.LARGE,
  });
  const icon = isGenericDataSource ? (
    <span className={iconClassnames}>
      <IcomoonIcon name="q-mark" size={16} />
    </span>
  ) : (
    <DataSourceIcon className={iconClassnames} schema={schema} />
  );

  return (
    <div className="DataSourceFieldRenderer GenericFieldRenderer">
      {icon}
      <div className={valueClassnames} data-term-field={fieldId} data-term-value-type="string">
        <TruncateWithTooltip
          id={uniqueId(`DataSourceFieldRenderer-${value}-`)}
          text={label}
          placement={TooltipPlacement.BOTTOM}
        />
      </div>
    </div>
  );
};
